<template>
  <div class="app-inner fixed fixed-head-3">
    <!--/-->
    <div class="app-head">
      <common-header></common-header>
      <common-nav></common-nav>
      <el-row class="c_nav_menu_wrapper c_subnav">
        <el-menu :default-active="$route.path" class="c_nav_menu" mode="horizontal" router>
          <el-menu-item index="/sale/sales-forecast">销售预测</el-menu-item>
        </el-menu>
      </el-row>
    </div>

    <!--/-->
    <div class="app-body">
      <my-bscroll>
        <router-view></router-view>
      </my-bscroll>
    </div>
  </div>
</template>

<script>
export default {
  data :function() {
    return { }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/sale/_layout.vue